/** Error codes shared between server responses and client rendering. */
export const ErrorCode = {
    NO_PERMISSION: 'NO_PERMISSION',
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    TRANSITION_NOT_ALLOWED: 'TRANSITION_NOT_ALLOWED',
    NEXT_STEP_REQUIRED: 'NEXT_STEP_REQUIRED',
    CONFLICT: 'CONFLICT',
    /** Booking page: the chosen time was taken in the meantime (Buchungsseite 03). */
    SLOT_TAKEN: 'SLOT_TAKEN',
    RATE_LIMITED: 'RATE_LIMITED',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    TWO_FACTOR_REQUIRED: 'TWO_FACTOR_REQUIRED',
    /** `TWO_FACTOR_MODE=optional`: a setup session (wizard step `security` open) on a full-session route (D-338). */
    SETUP_REQUIRED: 'SETUP_REQUIRED',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    LINK_EXPIRED: 'LINK_EXPIRED',
    MODULE_DISABLED: 'MODULE_DISABLED',
    INTERNAL: 'INTERNAL',
    /** A financier opens a financing that is not assigned to him (Finanzierer 09). */
    FINANCING_NOT_ASSIGNED: 'FINANCING_NOT_ASSIGNED',
    /** A client portal route without a live portal session (Mandantenportal 11). */
    PORTAL_UNAUTHENTICATED: 'PORTAL_UNAUTHENTICATED',
    /** Portal login on an unknown device: the confirmation code is still missing (Mandantenportal 12). */
    PORTAL_CODE_REQUIRED: 'PORTAL_CODE_REQUIRED',
    /**
     * Unused since D-333 (owner decision 29.10.2026: the legal texts no longer gate the portal). Kept in the catalog so
     * clients that still know the code keep compiling; no route returns it.
     */
    PORTAL_NOT_PUBLISHED: 'PORTAL_NOT_PUBLISHED',
    /** The chosen portal address cannot be used (taken, reserved, zone unknown — Admin 06). */
    DOMAIN_UNAVAILABLE: 'DOMAIN_UNAVAILABLE',
    /** First admin: the 6-digit e-mail code is wrong (Admin 02, `details.remaining`). */
    EMAIL_CODE_INVALID: 'EMAIL_CODE_INVALID',
    /** Deactivating a user without a successor (Admin 06, invariant 7). */
    SUCCESSOR_REQUIRED: 'SUCCESSOR_REQUIRED',
    /** A payment method or payment action while no payment provider is connected (M8, D-07/P-37). */
    PAYMENTS_NOT_ACTIVE: 'PAYMENTS_NOT_ACTIVE',
    /** A step of the Twilio journey before its predecessor is done (Einstellungen 25/26). */
    TELEPHONY_STEP_LOCKED: 'TELEPHONY_STEP_LOCKED',
    /** Buying a Twilio number while `TWILIO_NUMBER_PURCHASE` is off in this environment (Einstellungen 26). */
    NUMBER_PURCHASE_DISABLED: 'NUMBER_PURCHASE_DISABLED',
    /** PATCH of a field that an external system (TeamProQ) owns while its connection is `import_only` (D-174). */
    EXTERNAL_MANAGED_FIELD: 'EXTERNAL_MANAGED_FIELD',
    /** Deleting/adding a record that an external system owns while its connection is `import_only`. */
    EXTERNAL_MANAGED_RECORD: 'EXTERNAL_MANAGED_RECORD',
    /** Reserving/selecting a unit whose sales release („Vertriebsfreigabe") is off. */
    UNIT_NOT_RELEASED: 'UNIT_NOT_RELEASED',
    /** Reserving/selecting a unit that an external system reports as reserved, exclusive or sold. */
    UNIT_EXTERNALLY_BLOCKED: 'UNIT_EXTERNALLY_BLOCKED',
    /** TeamProQ answered 401/403: token revoked or the publication withdrawn (docs/integrations/teamproq.md). */
    TPQ_UNAUTHORIZED: 'TPQ_UNAUTHORIZED',
    /** TeamProQ is not reachable or keeps answering 429/5xx after the retries. */
    TPQ_UNAVAILABLE: 'TPQ_UNAVAILABLE',
    /** A referrer partner („Tippgeber-Partner") that does not exist in the organization (D-248). */
    REFERRER_PARTNER_NOT_FOUND: 'referrer_partner_not_found',
    /** Deleting a referrer partner that contacts, deals or self-disclosures reference — deactivate it instead. */
    REFERRER_PARTNER_IN_USE: 'referrer_partner_in_use',
    /** The intake link `/t/<token>` of a deactivated partner (or a locked organization). */
    REFERRER_INTAKE_INACTIVE: 'referrer_intake_inactive',
    /** The intake link `/t/<token>` is past its expiry (730 days; rotated in the settings). */
    REFERRER_INTAKE_EXPIRED: 'referrer_intake_expired',
    /** The intake link `/t/<token>` is unknown. */
    REFERRER_INTAKE_INVALID: 'referrer_intake_invalid',
    /** Editing a servicing membership that the parent organization maintains (0045, PKV M0). */
    SERVICING_MEMBERSHIP_LOCKED: 'SERVICING_MEMBERSHIP_LOCKED',
    /** Hanging an organization below itself or one of its own descendants (0045, PKV M0). */
    ORGANIZATION_TREE_CYCLE: 'ORGANIZATION_TREE_CYCLE',
    /** Confirming a property's base data while required fields are missing (Nico feedback FB-004, D-319). */
    BASE_DATA_INCOMPLETE: 'BASE_DATA_INCOMPLETE',
};
//# sourceMappingURL=errors.js.map